import { formatNumber } from "./BudgetGrid";
import { budgetStatusFor } from "./BudgetProgressBar";

// Anillo circular con el % de presupuesto consumido en el centro — mas grafico
// que una barra delgada, pensado para espacios chicos como el navbar.
export default function BudgetGauge({ asignado, pct, size = 40, strokeWidth = 4, labelClass = "text-[9px]" }) {
    if (asignado <= 0) return null;

    const status = budgetStatusFor(pct);
    const pctLabel = formatNumber(pct).replace(/\.00$/, "");
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (Math.min(pct, 100) / 100) * circumference;

    return (
        <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
            <svg width={size} height={size} className="-rotate-90">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    className="stroke-gray-200"
                    fill="none"
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    className={`${status.stroke} transition-all duration-300`}
                    fill="none"
                />
            </svg>
            <span className={`absolute inset-0 flex items-center justify-center font-bold ${labelClass} ${status.text}`}>
                {pctLabel}%
            </span>
        </div>
    );
}
